import React from 'react'

export default function AboutPage() {
    return <div>
        <h1>Eyo what's up its me Rat Maze</h1>
        <p>This page is a WIP, come back later!</p>
    </div>
}